import koalaImage from "../../assets/HomePage/KoalaSection.jpg";

export default function HeroSection() {
	return (
		<section
			className="relative bg-center bg-backgroundAlt text-white bg-blend-multiply overflow-hidden"
			style={{
				backgroundImage: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAPUlEQVQIW2NkgALtmsTNV1vm+zLCBHQqUjez3HpszKhTnbL5D+NfBparz4yvrN8pBVZhEOT17MK6bVIgNgBUvBO1R5/vswAAAABJRU5ErkJggg=="),url(${koalaImage})`,
				backgroundRepeat: 'repeat, no-repeat',
				backgroundSize: 'auto, cover',
				backgroundPosition: 'center',
				backgroundAttachment: 'scroll',
			}}
		>
			<div className="relative px-4 mx-auto max-w-screen-xl text-center 
                  py-10 sm:py-16 lg:py-32 
                  flex flex-col justify-center items-center 
                  min-h-[300px] sm:min-h-[400px] md:min-h-[500px]">
				{/* Title */}
				<h1 className="mb-4 text-4xl font-extrabold leading-none text-white md:text-6xl lg:text-8xl [text-shadow:_7px_3px_0px_#3D8D7A]">
					Koala Be Where
				</h1>

				{/* Sub Title */}
				<p className="mb-8 text-lg font-normal text-background lg:text-xl sm:px-16 lg:px-48">
					Snap a koala, protect their future.
				</p>

				{/* Button */}
				<div className="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0">
					<a
						href="/map"
						className="group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-md border border-neutral-200 bg-transparent px-6 font-medium text-white transition-all duration-100 [box-shadow:5px_5px_#3D8D7A] hover:translate-x-[3px] hover:translate-y-[3px] hover:[box-shadow:0px_0px_rgb(61_141_122)]"
					>
						Explore
						<svg
							className="w-4 h-4 ms-2 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
						</svg>
					</a>
				</div>

				<div className="flex text-white flex-col md:flex-row text-base mt-16">
					<div className="hero-guide-item">
						<svg className="w-12 h-12 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
							<path fillRule="evenodd" d="M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" clipRule="evenodd" />
						</svg>
						<span>Take a photo</span>
					</div>
					<div className="hero-guide-item">
						<svg className="w-12 h-12 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
							<path fillRule="evenodd" d="M12 3a1 1 0 0 1 .78.375l4 5a1 1 0 1 1-1.56 1.25L13 6.85V14a1 1 0 1 1-2 0V6.85L8.78 9.626a1 1 0 1 1-1.56-1.25l4-5A1 1 0 0 1 12 3ZM9 14v-1H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v1a3 3 0 1 1-6 0Zm8 2a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z" clipRule="evenodd" />
						</svg>
						<span>Upload it to our platform</span>
					</div>
					<div className="hero-guide-item">
						<svg className="w-12 h-12 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
							<path fillRule="evenodd" d="M12 2c-.791 0-1.55.314-2.11.874l-.893.893a.985.985 0 0 1-.696.288H7.04A2.984 2.984 0 0 0 4.055 7.04v1.262a.986.986 0 0 1-.288.696l-.893.893a2.984 2.984 0 0 0 0 4.22l.893.893a.985.985 0 0 1 .288.696v1.262a2.984 2.984 0 0 0 2.984 2.984h1.262c.261 0 .512.104.696.288l.893.893a2.984 2.984 0 0 0 4.22 0l.893-.893a.985.985 0 0 1 .696-.288h1.262a2.984 2.984 0 0 0 2.984-2.984V15.7c0-.261.104-.512.288-.696l.893-.893a2.984 2.984 0 0 0 0-4.22l-.893-.893a.985.985 0 0 1-.288-.696V7.04a2.984 2.984 0 0 0-2.984-2.984h-1.262a.985.985 0 0 1-.696-.288l-.893-.893A2.984 2.984 0 0 0 12 2Zm3.683 7.73a1 1 0 1 0-1.414-1.413l-4.253 4.253-1.277-1.277a1 1 0 0 0-1.415 1.414l1.985 1.984a1 1 0 0 0 1.414 0l4.96-4.96Z" clipRule="evenodd" />
						</svg>
						<span>AI validates it</span>
					</div>
				</div>
			</div>
		</section>
	);
}